import SetPasswordRequestModelBase from '../_generated/modelBases/set-password-request-model-base';

export default class SetPasswordRequestModel extends SetPasswordRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
